import { Select, SelectProps } from 'antd';

const SelectForm = (props: SelectProps) => {
  return (
    <Select
      allowClear
      optionFilterProp="children"
      filterOption={(input: any, option: any) => {
        if (typeof option?.label === 'number') {
          return option.label.toString().includes(input);
        }
        return (option?.label ?? '')
          .toString()
          .toLowerCase()
          .includes(input.toLowerCase());
      }}
      filterSort={(optionA: any, optionB: any) => {
        if (
          typeof optionA?.label === 'number' ||
          typeof optionB?.label === 'number'
        ) {
          return null;
        }

        if (optionA.value === 'all') return null;

        if (optionB.value === 'all') return null;

        return (optionA?.label ?? '')
          .toLowerCase()
          .localeCompare((optionB?.label ?? '').toLowerCase());
      }}
      size="large"
      showSearch
      className={`w-full ${props.className}`}
      {...props}
    />
  );
};
const SelectForm_v2 = (props: SelectProps) => {
  return (
    <Select
      allowClear
      optionFilterProp="children"
      filterOption={(input: any, option: any) => {
        if (typeof option?.label === 'number') {
          return option.label.toString().includes(input);
        }
        return (option?.label ?? '')
          .toString()
          .toLowerCase()
          .includes(input.toLowerCase());
      }}
      filterSort={(optionA: any, optionB: any) => {
        if (
          typeof optionA?.label === 'number' ||
          typeof optionB?.label === 'number'
        ) {
          return null;
        }
        return (optionA?.label ?? '').toLowerCase();
        // .localeCompare((optionB?.label ?? '').toLowerCase());
      }}
      size="large"
      showSearch
      className={`w-full ${props.className}`}
      {...props}
    />
  );
};

export default SelectForm;
export { SelectForm_v2 };
